/* =====================================================================
   FACTQRY — Barre de recherche LIVE (suggestions sous la barre)
   ---------------------------------------------------------------------
   S'attache à TOUTES les barres de recherche du site (header + page
   recherche) et affiche, pendant la frappe, un menu de suggestions :
     • Recherches associées -> collection si elle existe, sinon /search
       (réutilise le moteur window.FactqrySearch)
     • Produits (API Shopify /search/suggest.json)
   Style : factqry-live-search.css (cohérent avec le site).
   ===================================================================== */
(function () {
  'use strict';

  var INPUT_SELECTORS = '.factqry-header-search-input, .fq-search__input, .search__input, .fq-search-input';
  var MIN_CHARS = 2;
  var DEBOUNCE = 160;
  var PRODUCT_LIMIT = 5;
  var ASSOC_LIMIT = 6;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function searchUrl(q) {
    var base = (window.routes && window.routes.search_url) || '/search';
    return base + '?q=' + encodeURIComponent(q) + '&type=product';
  }

  // URL "voir tout" : collection correspondante si elle existe (ex. foot /
  // football -> /collections/t-shirt-football), sinon la page de recherche.
  function allResultsUrl(q) {
    var FS = window.FactqrySearch;
    if (FS && typeof FS.buildTermUrl === 'function') {
      return FS.buildTermUrl(q);
    }
    return searchUrl(q);
  }

  // --- Produits via l'API de suggestion native de Shopify ---
  function fetchProducts(q, signal) {
    // FACTQRY-HOOK (2026-10-11) : adresse de la langue de la page (/en/search/suggest…) : titres et liens traduits
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    var url = base + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + PRODUCT_LIMIT +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { signal: signal, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        try { return data.resources.results.products || []; }
        catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  // --- Recherches associées via le moteur partagé (collections) ---
  function fetchAssociated(q) {
    var FS = window.FactqrySearch;
    if (!FS || typeof FS.generateSuggestions !== 'function') return Promise.resolve([]);
    return Promise.resolve(FS.generateSuggestions(q)).then(function (terms) {
      return (terms || []).slice(0, ASSOC_LIMIT).map(function (t) {
        return {
          label: FS.capitalize ? FS.capitalize(t) : t,
          url: FS.buildTermUrl ? FS.buildTermUrl(t) : searchUrl(t)
        };
      });
    }).catch(function () { return []; });
  }

  // Collections de la boutique dont le nom correspond à la saisie
  // (ex. "couple", "amour", "beauf"...). Priorité aux noms qui COMMENCENT
  // par la saisie, puis qui la contiennent. Dédoublonné par collection.
  function matchCollections(q) {
    var FS = window.FactqrySearch;
    if (!FS || !FS.COLLECTION_MAP) return [];
    var nq = (FS.normalize ? FS.normalize(q) : String(q).toLowerCase()).trim();
    if (!nq) return [];
    var seen = {}, starts = [], contains = [];
    Object.keys(FS.COLLECTION_MAP).forEach(function (key) {
      var handle = FS.COLLECTION_MAP[key];
      if (seen[handle]) return;
      var idx = key.indexOf(nq);
      if (idx === -1) return;
      var item = { label: FS.capitalize ? FS.capitalize(key) : key, url: ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'collections/' + handle, handle: handle };
      if (idx === 0) { seen[handle] = 1; starts.push(item); }
      else { contains.push(item); }
    });
    contains.forEach(function (item) {
      if (seen[item.handle]) return;
      seen[item.handle] = 1;
      starts.push(item);
    });
    return starts.slice(0, 6);
  }

  function render(box, q, products, assoc, collections) {
    var html = '';
    var shownUrls = {};
    collections = collections || [];

    if (collections.length) {
      html += '<div class="fq-live__section">' +
        '<span class="fq-live__label">' + ((window.fqStrings && window.fqStrings.searchCollections) || 'Collections') + '</span>' +
        '<div class="fq-live__chips">' +
        collections.map(function (c) {
          shownUrls[c.url] = 1;
          return '<a class="fq-live__chip fq-live__chip--collection" href="' + c.url + '">' + escapeHtml(c.label) + '</a>';
        }).join('') +
        '</div></div>';
    }

    // Suggestions associées, dédoublonnées des collections déjà affichées.
    var assocFiltered = assoc.filter(function (a) { return !shownUrls[a.url]; });
    if (assocFiltered.length) {
      html += '<div class="fq-live__section">' +
        '<span class="fq-live__label">' + ((window.fqStrings && window.fqStrings.searchSuggestions) || 'Suggestions') + '</span>' +
        '<div class="fq-live__chips">' +
        assocFiltered.map(function (a) {
          return '<a class="fq-live__chip" href="' + a.url + '">' + escapeHtml(a.label) + '</a>';
        }).join('') +
        '</div></div>';
    }

    if (products.length) {
      html += '<div class="fq-live__section">' +
        '<span class="fq-live__label">' + ((window.fqStrings && window.fqStrings.searchProducts) || 'Produits') + '</span>' +
        '<div class="fq-live__products">' +
        products.map(function (p) {
          var img = p.image
            ? '<img class="fq-live__thumb" src="' + p.image + '" alt="" width="46" height="46" loading="lazy">'
            : '<span class="fq-live__thumb fq-live__thumb--empty" aria-hidden="true"></span>';
          return '<a class="fq-live__product" href="' + p.url + '">' + img +
            '<span class="fq-live__product-title">' + escapeHtml(p.title) + '</span></a>';
        }).join('') +
        '</div></div>';
    }

    if (!collections.length && !assocFiltered.length && !products.length) {
      html += '<div class="fq-live__empty">' + ((window.fqStrings && window.fqStrings.searchNoSuggestion) || 'Aucune suggestion pour « [q] »').replace('[q]', escapeHtml(q)) + '</div>';
    }

    html += '<a class="fq-live__all" href="' + allResultsUrl(q) + '">' +
      ((window.fqStrings && window.fqStrings.searchAllResults) || 'Voir tous les résultats pour « [q] »').replace('[q]', escapeHtml(q)) +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</a>';

    box.innerHTML = html;
    box.classList.add('is-open');
  }

  function attach(input) {
    if (input.dataset.fqLiveBound === '1') return;
    input.dataset.fqLiveBound = '1';

    var form = input.closest('form');
    if (!form) return;
    if (getComputedStyle(form).position === 'static') form.style.position = 'relative';

    var box = document.createElement('div');
    box.className = 'fq-live';
    form.appendChild(box);

    var controller = null;

    function close() {
      box.classList.remove('is-open');
      box.innerHTML = '';
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { close(); return; }

      if (controller && controller.abort) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var signal = controller ? controller.signal : undefined;

      var collections = matchCollections(q);
      Promise.all([fetchProducts(q, signal), fetchAssociated(q)]).then(function (res) {
        if (input.value.trim() !== q) return; // requête obsolète
        render(box, q, res[0] || [], res[1] || [], collections);
      });
    }, DEBOUNCE);

    input.addEventListener('input', run);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS) run();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
  }

  function init() {
    var inputs = document.querySelectorAll(INPUT_SELECTORS);
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Recharge de section dans l'éditeur de thème
  document.addEventListener('shopify:section:load', init);
})();
